import { render, staticRenderFns } from "./PopularRoutes.vue?vue&type=template&id=fde48132&scoped=true&"
import script from "./PopularRoutes.vue?vue&type=script&lang=js&"
export * from "./PopularRoutes.vue?vue&type=script&lang=js&"
import style0 from "./PopularRoutes.vue?vue&type=style&index=0&id=fde48132&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde48132",
  null
  
)

export default component.exports